import React from "react";
var __jsx = React.createElement;
import { SWRConfig } from "swr";
import { Provider } from "react-redux";
import { useEffect } from "react";
import callInSWR from "apiclient/callInSWR";
import { store } from "redux/store/store";
import { withLayout } from "components/fragments/global/Layout";
import AuthenticatedRoute from "components/AuthenticatedRoute";
import BaseLayout from "components/fragments/global/Layout/Base";
import Notification from "services/notification/Notification";
import AppContextProvider from "contexts/appContext";
import "public/static/styles/globals/reset.css";
import "public/static/styles/globals/colors.css";
import "public/static/styles/globals/graphene-colors.css";
import "public/static/styles/globals/css-properties.css";
import "public/static/styles/globals/typography.css";
import "public/static/styles/globals/fontface.css";
import "public/static/styles/globals/animation.css";
import "public/static/styles/globals/show-hide.css";
import { EngVillageThemeProvider } from "public/static/styles/theme/EngVillage/EngVillageThemeProvider";

/**
 * Main next.js application for EV.
 * @param {*} param0
 * @returns
 */
export default function MyApp(_ref) {
  var Component = _ref.Component,
    pageProps = _ref.pageProps;
  useEffect(function () {
    // Catch clicks on  OneTrust external script buttons
    document.addEventListener("click", function (event) {
      // console.log("EV Event Listener: ", event.target, event.target.textContent, event.target.tagName);
      // Button: Accept all Cookies OR Confirm my choices
      if (event.target && (event.target.matches("#onetrust-accept-btn-handler") || event.target.textContent === "Confirm my choices")) {
        window.location.reload();
      }
    });
  }, []);
  if (!Component.getLayout) {
    var _WithLayoutComponent = withLayout(Component);
    _WithLayoutComponent.skeleton = Component.skeleton;
    _WithLayoutComponent.title = Component.title;
    _WithLayoutComponent.isPublic = Component.isPublic;
    // eslint-disable-next-line no-param-reassign
    Component = _WithLayoutComponent;
  }
  var _Component = Component,
    title = _Component.title,
    isPublic = _Component.isPublic,
    getLayout = _Component.getLayout,
    skeleton = _Component.skeleton;

  // Use the layout defined at the page level, if available
  // Return a wrapped response.  NOTE that the AuthenticatedRoute wrapper is at
  // the top level.  Keeping it above the page / theme will prevent Next.js from
  // unnecessarily reloading content!
  // The response is also wrapped in a ThemeProvider to override MUI behavior!

  return /*#__PURE__*/React.createElement(Provider, {
    store: store
  }, /*#__PURE__*/React.createElement(SWRConfig, {
    value: {
      fetcher: callInSWR
    }
  }, /*#__PURE__*/React.createElement(AppContextProvider, null, /*#__PURE__*/React.createElement(EngVillageThemeProvider, null, /*#__PURE__*/React.createElement(Notification, null), /*#__PURE__*/React.createElement(BaseLayout, {
    title: title,
    isPublic: isPublic
  }, /*#__PURE__*/React.createElement(AuthenticatedRoute, {
    skeleton: skeleton,
    isPublic: !!isPublic
  }, getLayout(/*#__PURE__*/React.createElement(Component, pageProps))))))));
}
export function reportWebVitals() {}